'use client';

import React, { useState, createContext, useContext } from 'react';

// 定义上下文类型
interface ContactUsFromContextType {
    getFormStatus: () => boolean;
    openForm: () => void;
    closeForm: () => void;
}

const ContactUsFromContext = createContext<ContactUsFromContextType>({
    getFormStatus() {
        return false;
    },
    openForm: () => {},
    closeForm: () => {},
});

export function ContactUsFromContextProvider({
    children,
}: Readonly<{
    children: React.ReactNode;
}>) {
    const [isOpen, setIsOpen] = useState(false);

    const openForm = () => {
        setIsOpen(true);
    };

    const closeForm = () => {
        setIsOpen(false);
    };

    const getFormStatus = () => {
        return isOpen;
    };

    return (
        <ContactUsFromContext.Provider
            value={{
                getFormStatus,
                openForm,
                closeForm,
            }}
        >
            {children}
        </ContactUsFromContext.Provider>
    );
}

export default function useContactUsContext() {
    return useContext(ContactUsFromContext);
}
